export function Myloader() {
  return <div className="myloader" />;
}
